// Data layer for the new Check-ins UI. The team/standup endpoints go through the
// /bot gateway (trooprbot); the legacy teamsync CRUD hits troopr-api directly,
// the same routes the old UI used.
import axios from 'axios';

// Teams for the switcher.
export const listTeams = (wId) =>
  axios.get(`/bot/api/w/${wId}/workspace-teams?all=true`);

// All check-ins for a team (used to derive the 4 type tiles + legacy cards).
export const listForTeam = (wId, teamId, isDefault) =>
  axios.get(`/api/w/${wId}/teamSync/userSelected`, {
    params: { showAll: true, teamId, isDefault },
  });

// The self-writing standup, drafted live from signals (dry-run; no posting).
export const previewStandup = (wId, teamId) =>
  axios.get(`/bot/api/w/${wId}/workspace-teams/${teamId}/standup/preview`);

// Seed durable memory from recent activity.
export const backfillStandup = (wId, teamId, days) =>
  axios.post(
    `/bot/api/w/${wId}/workspace-teams/${teamId}/standup/backfill`,
    {},
    { params: days ? { days } : {} }
  );

// Create / idempotently update the AI standup (engine:'ai').
export const saveAiStandup = (wId, payload) =>
  axios.post(`/api/w/${wId}/createNewTeamSync`, payload);

// Legacy check-in update (schedule/channel/questions/enable) for the other types.
export const updateCheckin = (wId, tId, payload) =>
  axios.post(`/api/w/${wId}/teamSync/${tId}/teamsyncupdates`, payload);

// Enable / disable a check-in (createInstance drives scheduling).
export const setEnabled = (wId, tId, enabled) =>
  updateCheckin(wId, tId, { createInstance: enabled });
